/* eslint import/prefer-default-export: off */

enum groups {
  CORPORATE_PARTNERSHIP = 'corporate_partnership',
}

export { groups }
